export enum PortfolioStatisticsFilter {
  LAST_24_HOURS = '24 hours',
  LAST_7_DAYS = 'Last 7 days',
  LAST_30_DAYS = 'Last 30 days',
  LAST_6_MONTHS = 'Last 6 months',
  LAST_12_MONTHS = 'Last 12 months',
  ALL_TIME = 'All time',
}
